import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import { Body1 } from '../FontStyles';
import baseTheme from '../../themes/baseTheme';
import { Link } from 'react-router-dom';

const DefaultCell = Styled(Flex)`
border-bottom: ${baseTheme.border};

`;

export default props => (
  <DefaultCell {...props}>
    {props.to ? (
      <Link to={props.to}>
        <Body1>{props.children}</Body1>
      </Link>
    ) : (
      <Body1>{props.children}</Body1>
    )}
  </DefaultCell>
);
